export const spritePath = {
  computed: {
    spritePath () {
      return process.env.VUE_APP_SVG_SPRITE_PATH
    }
  }
}
